import React from 'react';
import { useIntl } from 'react-intl';

const AdminFiltersHeader = () => {
  const intl = useIntl();

  return (
    <header id="filters-list-header" className="page-header">
      <h3 className="page-title">
        {intl.formatMessage({ defaultMessage: 'Filters' })}
      </h3>
    </header>
  );
};

export default AdminFiltersHeader;
